import isBoolean from 'lodash-es/isBoolean'
import isNumber from 'lodash-es/isNumber'
import isString from 'lodash-es/isString'

import { EMPTY_STRING } from '../../constants/common'

/**
 * @param {React.ReactNode} value
 */
export function isEmptyNode(value) {
  return (
    value == null ||
    (isString(value) && value.trim() === EMPTY_STRING) ||
    (Array.isArray(value) && (value?.length ?? 0) === 0)
  )
}

/**
 * @param {React.ReactNode} value
 */
export function isTextNode(value) {
  return isBoolean(value) || isNumber(value) || isString(value)
}
